export default function AboutUsFooter() {
    return (
        <div className="about_us_footer">
            <h4 className="font-Quick font-med">About Us</h4>
            <p className="font-Quick font-reg">
            TeacherInd offers One on One Live Interactive Sessions for students in classes 1-12 across CBSE, ICSE, and State syllabuses. Our personalized, one-on-one online tuitions provide the same individual attention as home tutors, but with the added benefits of AI-driven tracking, analysis, and efficient learning. We offer comprehensive subject coverage for classes 1-7 (Math, Science, Hindi, English, EVS, Social Studies, Malayalam), 8-10 (Math, Science, Hindi, English, Physics, Chemistry, Biology), and 11-12 (Mathematics, Physics, Chemistry, English, Biology, Computer Science, Accountancy).
            </p>
            <div></div>
        </div>
    )
}
